<template>
  <tr>
    <td width="50%">
      <table v-if="company && company.location" class="table">
        <tbody>
          <tr>
            <td>
              <strong>{{ company.name }}</strong>
            </td>
          </tr>
          <tr>
            <td>{{ company.location.address }}</td>
          </tr>
          <tr>
            <td>
              {{
                company.location.city +
                  ", " +
                  company.location.state +
                  " " +
                  company.location.postal_code
              }}
            </td>
          </tr>
          <tr>
            <td>{{ company.location.country }}</td>
          </tr>
          <tr v-if="company.state_license_number">
            <td>State License: {{ company.state_license_number }}</td>
          </tr>
          <tr v-if="company.state_delivery_license_number">
            <td>
              Delivery License: {{ company.state_delivery_license_number }}
            </td>
          </tr>
        </tbody>
      </table>
    </td>
    <td style="width: 50%;">
      <table class="table" align="left" style="width: 70%; margin-left: 20px" v-if="driver">
        <tbody>
          <tr>
            <td><strong>Driver Name:</strong></td>
            <td>{{ driver.first_name + " " + driver.last_name }}</td>
          </tr>
          <tr>
            <td><strong>Driver License:</strong></td>
            <td>{{ driver.driver_license_number }}</td>
          </tr>
          <tr>
            <td><strong>Vehicle:</strong></td>
            <td>{{ vehicleName }}</td>
          </tr>
          <tr>
            <td><strong>Vehicle VIN:</strong></td>
            <td>{{ vehicle.vin }}</td>
          </tr>
          <tr>
            <td><strong>Vehicle Registration:</strong></td>
            <td>{{ vehicle.registration_number }}</td>
          </tr>
          <tr>
            <td><strong>License Plate:</strong></td>
            <td>{{ vehicle.license_plate_number }}</td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script>
export default {
  name: "ManifestHeader",

  props: ["driver", "vehicle", "company", "vehicleName"],
};
</script>
<style scoped>
.table td, .table th {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/job/batch/ManifestHeader.vue